module.exports = __webpack_public_path__ + "static/media/logout.0122ff8a.svg";